export default "__VITE_ASSET__CUZhfbqQ__"